<template>
  <button
    class="ce-btn-as-link"
    v-if="activeUser"
    @click.prevent.stop="toggleFavorite">
    <fa-icon :icon="favoriteStateIcon" />

    <span v-if="showLabel">
      {{ label }}
    </span>
  </button>
  <tooltip
    v-else
    :content="$t('formulationRepository.favoriteAction.loginForFavorites')">
    <button
      class="ce-btn-as-link disabled"
      @click.prevent>
      <fa-icon :icon="favoriteStateIcon" />

      <span v-if="showLabel">
        {{ label }}
      </span>
    </button>
  </tooltip>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import FormulationRepositoryService from 'services/FormulationRepositoryService';

export default {
  props: {
    formulation: {
      type: Object,
      required: true
    },
    shade: {
      type: Object,
      required: true,
    },
    showLabel: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('user', ['activeUser']),
    ...mapGetters('user', ['token']),
    isFavorite() {
      if (this.activeUser) {
        return this.activeUser.favoriteFormulations
            && Array.isArray(this.activeUser.favoriteFormulations)
            && this.activeUser.favoriteFormulations.includes(this.formulation.id.toString());
      }

      return false;
    },
    favoriteStateIcon() {
      return this.isFavorite ? ['fas', 'star'] : ['far', 'star'];
    },
    label() {
      if (!this.showLabel) {
        return null;
      }

      if (this.isFavorite) {
        return this.$t('formulationRepository.favoriteAction.remove');
      }

      return this.$t('formulationRepository.favoriteAction.add');
    }
  },
  methods: {
    async toggleFavorite() {
      if (!this.activeUser) {
        return;
      }

      try {
        const rowId = this.formulation.id.toString();

        const favorites = new Set(
          this.activeUser.favoriteFormulations && Array.isArray(this.activeUser.favoriteFormulations)
            ? this.activeUser.favoriteFormulations
            : []
        );

        let isAdd = true;

        if (favorites.has(rowId)) {
          isAdd = false;
          favorites.delete(rowId);
        } else {
          favorites.add(rowId);
        }

        this.$trackEvent(
          'Formulation Repository',
          isAdd ? 'Add Favorite' : 'Remove Favorite',
          {
            shadeId: this.shade.id,
            shade: this.shade.title,
            formulationId: rowId,
            formulation: this.formulation.title,
            industries: this.formulation.industries,
          }
        );

        await FormulationRepositoryService.toggleFavorite(rowId, this.token);

        await this.$store.dispatch('user/updateLocalUserInfo', {
          favoriteFormulations: [...favorites],
        });
      } catch (e) {
        // noop
      }
    },
  }
};

</script>
